export const CONTACT = {
  owner: "Nick Eklund",
  business: "Eklund Land Management",
  phone: "918-734-9052",
  phoneHref: "tel:9187349052",
  location: "Broken Arrow, OK",
  tagline: "Turning unusable land into usable property.",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/eklund_land___management/",
  instagramHandle: "@eklund_land___management",
  facebook: "https://www.facebook.com/profile.php?id=61576658716988",
  // Placeholder — swap with Nick's direct Google review link when available
  googleReview: "https://www.google.com/search?q=Eklund+Land+Management+Broken+Arrow+OK",
};

export const SERVICES = [
  {
    id: "land-clearing",
    title: "Land Clearing",
    desc: "Brush, undergrowth and overgrowth removed to reveal usable acreage.",
    image:
      "https://images.unsplash.com/photo-1784704961408-d898427c69d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxkcm9uZSUyMHZpZXclMjBjbGVhcmVkJTIwbGFuZCUyMGZvcmVzdHxlbnwwfHx8fDE3ODU0MjU2MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gravel-driveways",
    title: "Gravel Driveways",
    desc: "Durable, properly graded drives built to handle Oklahoma weather.",
    image:
      "https://images.unsplash.com/photo-1763516763259-4f7ce3d19c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxncmF2ZWwlMjBkcml2ZXdheSUyMGNvbnN0cnVjdGlvbiUyMGhlYXZ5JTIwZXF1aXBtZW50fGVufDB8fHx8MTc4NTQyNTYwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "house-pads",
    title: "House Pads",
    desc: "Compacted, level building pads engineered for a solid foundation.",
    image:
      "https://images.pexels.com/photos/36657008/pexels-photo-36657008.jpeg",
  },
  {
    id: "grading-dirt-work",
    title: "Grading & Dirt Work",
    desc: "Precision grading for drainage, slope and a clean finished surface.",
    image:
      "https://images.unsplash.com/photo-1580901369227-308f6f40bdeb",
  },
  {
    id: "tree-removal",
    title: "Tree Removal",
    desc: "Safe removal of trees and stumps clearing the way for your project.",
    image:
      "https://images.unsplash.com/photo-1784704961408-d898427c69d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxkcm9uZSUyMHZpZXclMjBjbGVhcmVkJTIwbGFuZCUyMGZvcmVzdHxlbnwwfHx8fDE3ODU0MjU2MDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "trenching-excavation",
    title: "Trenching & Excavation",
    desc: "Utility trenches, digs and excavation done clean and to spec.",
    image:
      "https://images.unsplash.com/photo-1580901369227-308f6f40bdeb",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "New to Broken Arrow. Built for the long haul.",
    body: "I'm Nick Eklund, and I'm relocating to the Broken Arrow area to put down roots and build real relationships with the people here. Every job is a handshake and a reputation on the line.",
  },
  {
    num: "02",
    title: "Quality work at a fair price.",
    body: "No shortcuts, no surprise fees. Just honest, careful work with the right equipment — from the first cut of brush to the final pass of the grader.",
  },
  {
    num: "03",
    title: "Turning unusable land into usable property.",
    body: "Overgrown lots, uneven ground, no access. I clear it, shape it, and hand it back ready to build, drive on, or enjoy.",
  },
];

export const GALLERY = [
  {
    url: "https://customer-assets-v7afamib.emergentagent.net/job_broken-arrow-build/artifacts/fz0enf9e_image2%20%283%29.webp",
    label: "Loaded & Ready",
    portrait: false,
  },
  {
    url: "/jobs/snow.jpg?v=2",
    label: "Winter Snow Removal",
    portrait: true,
  },
  {
    url: "https://customer-assets-v7afamib.emergentagent.net/job_broken-arrow-build/artifacts/77esm8hf_image6.jpeg",
    label: "Forestry Mulching",
    portrait: false,
  },
  {
    url: "/jobs/hoodie.jpg",
    label: "On the Job",
    portrait: true,
  },
  {
    url: "https://customer-assets-v7afamib.emergentagent.net/job_broken-arrow-build/artifacts/bdr491fo_image5.jpeg",
    label: "Pond & Bank Clearing",
    portrait: false,
  },
];

export const OWNER_IMAGE =
  "https://customer-assets-v7afamib.emergentagent.net/job_broken-arrow-build/artifacts/1t9ktet4_image.png";

export const HERO_IMAGE =
  "https://customer-assets-v7afamib.emergentagent.net/job_broken-arrow-build/artifacts/b2wz82y7_image.png";

export const VIDEOS = [
  {
    src: "/videos/clip2.mp4?v=3",
    poster: "/videos/poster2.jpg?v=3",
    label: "On the Jobsite",
    orientation: "landscape",
  },
  {
    src: "/videos/clip1.mp4?v=3",
    poster: "/videos/poster1.jpg?v=4",
    label: "In the Field",
    orientation: "portrait",
  },
];
